module.exports = __webpack_public_path__ + "reception.png?f507ae49a6aa57fd3baa44603e592434";